var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8721 14.2778C27.8721 9.38788 27.8721 6.94296 26.353 5.42387C24.8339 3.90479 22.389 3.90479 17.4991 3.90479H12.3126C7.4228 3.90479 4.97776 3.90479 3.45877 5.42387C1.93965 6.94296 1.93965 9.38788 1.93965 14.2778V16.871C1.93965 21.7608 1.93965 24.2058 3.45877 25.7248C4.97776 27.244 7.4228 27.244 12.3126 27.244H17.4991C22.389 27.244 24.8339 27.244 26.353 25.7248C27.8721 24.2058 27.8721 21.7608 27.8721 16.871V14.2778Z",
    stroke: "#52565A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3887 3.90477V1.95984",
    stroke: "#52565A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42285 3.90477V1.95984",
    stroke: "#52565A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2236 10.3878H2.58783",
    stroke: "#52565A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.126 20.7607C8.126 20.9246 8.25878 21.0574 8.42262 21.0574C8.58646 21.0574 8.71924 20.9246 8.71924 20.7607C8.71924 20.5969 8.58646 20.4641 8.42262 20.4641C8.25878 20.4641 8.126 20.5969 8.126 20.7607Z",
    fill: "#52565A",
    stroke: "#52565A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.126 15.5743C8.126 15.7382 8.25878 15.871 8.42262 15.871C8.58646 15.871 8.71924 15.7382 8.71924 15.5743C8.71924 15.4105 8.58646 15.2777 8.42262 15.2777C8.25878 15.2777 8.126 15.4105 8.126 15.5743Z",
    fill: "#52565A",
    stroke: "#52565A",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 20.7607C14.6094 20.9246 14.7422 21.0574 14.906 21.0574C15.0699 21.0574 15.2026 20.9246 15.2026 20.7607C15.2026 20.5969 15.0699 20.4641 14.906 20.4641C14.7422 20.4641 14.6094 20.5969 14.6094 20.7607Z",
    fill: "#52565A",
    stroke: "#52565A",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 15.5743C14.6094 15.7382 14.7422 15.871 14.906 15.871C15.0699 15.871 15.2026 15.7382 15.2026 15.5743C15.2026 15.4105 15.0699 15.2777 14.906 15.2777C14.7422 15.2777 14.6094 15.4105 14.6094 15.5743Z",
    fill: "#52565A",
    stroke: "#52565A",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0923 20.7607C21.0923 20.9246 21.2251 21.0574 21.3889 21.0574C21.5528 21.0574 21.6855 20.9246 21.6855 20.7607C21.6855 20.5969 21.5528 20.4641 21.3889 20.4641C21.2251 20.4641 21.0923 20.5969 21.0923 20.7607Z",
    fill: "#52565A",
    stroke: "#52565A",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0923 15.5743C21.0923 15.7382 21.2251 15.871 21.3889 15.871C21.5528 15.871 21.6855 15.7382 21.6855 15.5743C21.6855 15.4105 21.5528 15.2777 21.3889 15.2777C21.2251 15.2777 21.0923 15.4105 21.0923 15.5743Z",
    fill: "#52565A",
    stroke: "#52565A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendericon);
export default __webpack_public_path__ + "static/media/calendericon.c68611a766410de0d872a1317a3d9241.svg";
export { ForwardRef as ReactComponent };